/**
 * 一覧でのモーダル不要化に伴いhandleの読み込みをコメントアウト
 */
// const mediaQuery = window.matchMedia('(max-width: 768px)');

// ページが読み込まれた時に実行
// handle(mediaQuery);

// ウィンドウサイズを変更しても実行（ブレイクポイントの監視）
// mediaQuery.addListener(handle);

function handle(mm) {
  	if (mm.matches) {
    	// ウィンドウサイズ768px以下のときの処理
		// console.log('aaa');
	} else {
		//swiperのaタグでスクロールしてしまうのを阻止
		$(function() {
			var isTouch = ('ontouchstart' in window);

			$(document).on('click', '.swiper-topic ul a', function() {
				return false;
			});

			$('.swiper-topic ul').bind({
				'touchstart mousedown': function(e) {
					e.preventDefault();
					this.pageX = (isTouch ? event.changedTouches[0].pageX : e.pageX);
					basePoint = this.left = parseFloat($(this).css('left'));
					this.touched = true;

					var goUrl = $(e.target).closest('a').attr('href');
					if(goUrl != undefined) {
						window.location.href = goUrl;
					}
				},
				'touchmove mousemove': function(e) {
					if(!this.touched) {
						return;
					}
					e.preventDefault();
					// this.left = parseFloat($(this).css('left')) - (this.pageX - (isTouch ? event.changedTouches[0].pageX : e.pageX) );
					// $(this).css({
					//     left: this.left
					// });
					// this.pageX = (isTouch ? event.changedTouches[0].pageX : e.pageX);
				},
				'touchend mouseup': function(e) {
					if(!this.touched) {
						return;
					}
					this.touched = false;
					if(basePoint - this.left > 30) {
						// 一定以上スワイプした場合は自動スライド
						$(this).css({
							left: basePoint
						});
					}
					else if(basePoint - this.left < -30) {
						// 一定以上スワイプした場合は自動スライド
						$(this).css({
							left: basePoint
						});

					} else if(Math.abs(basePoint - this.left) < 5) {

					}
					else {
						// 一定以上スワイプしていない場合は元の位置に戻す
						$(this).css({
							left: basePoint
						});
					}
				}
			});
		});
		$(function() {
			var isTouch = ('ontouchstart' in window);
			$(document).on('click', '.swiper ul a', function() {
				return false;
			});
			$('.swiper ul').bind({
				'touchstart mousedown': function(e) {
					e.preventDefault();
					this.pageX = (isTouch ? event.changedTouches[0].pageX : e.pageX);
					basePoint = this.left = parseFloat($(this).css('left'));
					this.touched = true;

					var goUrl = $(e.target).closest('a').attr('href');
					if(goUrl != undefined) {
						window.location.href = goUrl;
					}
				},
				'touchmove mousemove': function(e) {
					if(!this.touched) {
						return;
					}
					e.preventDefault();
					// this.left = parseFloat($(this).css('left')) - (this.pageX - (isTouch ? event.changedTouches[0].pageX : e.pageX) );
					// $(this).css({
					//     left: this.left
					// });
					// this.pageX = (isTouch ? event.changedTouches[0].pageX : e.pageX);
				},
				'touchend mouseup': function(e) {
					if(!this.touched) {
						return;
					}
					this.touched = false;
					if(basePoint - this.left > 30) {
						// 一定以上スワイプした場合は自動スライド

					} else if(basePoint - this.left < -30) {
						// 一定以上スワイプした場合は自動スライド

					} else if(Math.abs(basePoint - this.left) < 5) {
						// スワイプした距離が5px以下の場合はクリックの処理
						var goUrl = $(e.target).closest('a').attr('href');
						if(goUrl != undefined) {
							window.location.href = goUrl;
						}

					} else {
						// 一定以上スワイプしていない場合は元の位置に戻す
						$(this).css({
							left: basePoint
						});
					}
				}
			});
		});
	}
}



//-----------TOPへ戻る
function PageTopAnime() {
	var scroll = $(window).scrollTop();
	if (scroll >= 200){//上から200pxスクロールしたら
		$('#page-top').removeClass('DownMove');//#page-topについているDownMoveというクラス名を除く
		$('#page-top').addClass('UpMove');//#page-topについているUpMoveというクラス名を付与
	}else{
		if($('#page-top').hasClass('UpMove')){//すでに#page-topにUpMoveというクラス名がついていたら
			$('#page-top').removeClass('UpMove');//UpMoveというクラス名を除き
			$('#page-top').addClass('DownMove');//DownMoveというクラス名を#page-topに付与
		}
	}
}
// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function () {
	PageTopAnime();/* スクロールした際の動きの関数を呼ぶ*/
});

// ページが読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function () {
	PageTopAnime();/* スクロールした際の動きの関数を呼ぶ*/
});

// #page-topをクリックした際の設定
$('#page-top a').click(function () {
    $('body,html').animate({
        scrollTop: 0//ページトップまでスクロール
    }, 300);//ページトップスクロールの速さ。数字が大きいほど遅くなる
    return false;//リンク自体の無効化
});


//--------------要素をフェイドイン
// $(function () {
// 	$(window).scroll(function () {
// 	  const windowHeight = $(window).height();
// 	  const scroll = $(window).scrollTop();

// 	  $('.element').each(function () {
// 		const targetPosition = $(this).offset().top;
// 		if (scroll > targetPosition - windowHeight + 100) {
// 		  $(this).addClass("is-fadein");
// 		}
// 	  });
// 	});
//   });




//-----------高さをそろえる
  $(function() {
    $('.match-height').matchHeight();
  });


//   job-offerの日付取得
$(function () {
	var year = new Date().getFullYear();
	var month = new Date().getMonth() + 1;
	var date = new Date().getDate();

	var num = new Date().getDay();
	var weekday = ["日", "月", "火", "水", "木", "金", "土"];
	var week = weekday[num];
	$(".date").html(year + "年" + month + "月" + date + "日" + "(" + week + ")" );
});
